<template>
  <div class="content-8__content">
    <loading v-if="isLoading" />
    <table v-else class="even-color">
      <template v-if="tableList.length > 0">
        <thead>
          <tr>
            <th>
              <span>时间</span>
            </th>
            <th>
              <span>期数</span>
            </th>
            <th>
              <span>开奖号码</span>
            </th>
            <th colspan="2">
              <span>两面</span>
            </th>
            <th>
              <span>波色</span>
            </th>
            <th>
              <span>极值</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableList" :key="index">
            <td>
              <span>{{ formatDrawTime(item.drawTime) }}</span>
            </td>
            <td>
              <span>{{ item.period }}</span>
            </td>
            <td>
              <div class="tableballbox">
                <div class="tableballbox__item addplus">
                  <div class="ball color--primary size-middle circle">
                    <span class="ball__number">{{ item.balls[0] }}</span>
                  </div>
                </div>

                <div class="tableballbox__item addplus">
                  <div class="ball color--primary size-middle circle">
                    <span class="ball__number">{{ item.balls[1] }}</span>
                  </div>
                </div>

                <div class="tableballbox__item addequal">
                  <div class="ball color--primary size-middle circle">
                    <span class="ball__number">{{ item.balls[2] }}</span>
                  </div>
                </div>

                <div class="tableballbox__item">
                  <div class="ball color--red size-middle circle">
                    <span class="ball__number">{{ item.balls[0] + item.balls[1] + item.balls[2] }}</span>
                  </div>
                </div>
              </div>
            </td>
            <!-- 兩面-->
            <td :class="{ 'red': item.zongHeDanShuang === '单'}">
              <span>{{ item.zongHeDanShuang }}</span>
            </td>
            <td :class="{ 'red': item.zongHeDaXiao === '大' }">
              <span>{{ item.zongHeDaXiao }}</span>
            </td>
            <!-- 波色-->
            <td v-if="item.seBo === '和'">
              <span>{{ item.seBo }}</span>
            </td>
            <td
              v-else
              :class="{
                'red': item.seBo === '红',
                'blue': item.seBo === '蓝',
                'green': item.seBo === '绿'
              }"
            >
              <span>{{ item.seBo || '' }}波</span>
            </td>
            <!-- 極值-->
            <td
              :class="{
                'red': item.zongHeJiZhi === 'jiZhi_jiDa',
                'blue': item.zongHeJiZhi === 'jiZhi_jiXiao'
              }"
            >
              <span>{{ formatRuleCode(item.zongHeJiZhi) }}</span>
            </td>
          </tr>
        </tbody>
      </template>
      <NoData v-else />
    </table>
    <ClickMoreBtn v-if="moreBtnExists" :btn-hide="noMoreData" @show-more="showMoreInfo" />
  </div>
</template>

<script>
import { getRuleDetails_desktop } from '@/api/desktop/basic'
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'
import { getLotteryRuleList } from '@/utils/kaiJiang-Sean'
import * as moment from 'moment-mini'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import ClickMoreBtn from '@/components/web/pages/trend/ClickMoreBtn'
import chunk from 'lodash.chunk'
export default {
  name: 'Xy28KaiJiangTable',
  components: {
    Loading,
    NoData,
    ClickMoreBtn
  },
  props: {
    lotteryCode: {
      type: String,
      required: true,
      default: () => {
        console.error('KaiJiangTable required key "lotteryCode"')
        return ''
      }
    },
    periodFormat: {
      type: Object,
      required: true,
      default: () => {
        console.error('KaiJiangTable required key "periodFormat"')
        return {}
      }
    },
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      tableList: [],
      lotteryRuleList: getLotteryRuleList(this.lotteryType),
      routeName: this.$route.name,
      isLoading: false,
      chunkInfo: {
        lists: [],
        index: 0,
        last: 0,
        isLast: false
      }
    }
  },
  computed: {
    noMoreData() {
      return this.chunkInfo.isLast
    },
    moreBtnExists() {
      return !this.isLoading && this.tableList.length > 0
    }
  },
  watch: {
    periodFormat: {
      handler() {
        this.getTableList()
      },
      deep: true
    }
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList() {
      this.isLoading = true
      const query = {
        rules: this.lotteryRuleList
      }
      this.resetChunkInfo()

      switch (this.$route.query.trendType) {
        case 'LiShihKaiJiang': // 歷史開獎
          Object.assign(query, { ...this.periodFormat })
          break
        default:
          Object.assign(query, { date: moment().format('YYYY-MM-DD') })
          break
      }

      const [data, error] = await getRuleDetails_desktop(this.lotteryCode, query)
      if (error) return

      data.forEach(item => {
        item.zongHeDaXiao = ruleCodeMapping[item.zongHeDaXiao[0]]
        item.zongHeDanShuang = ruleCodeMapping[item.zongHeDanShuang[0]]
        item.seBo = ruleCodeMapping[item.seBo?.[0]] || ''
      })

      Object.assign(this.chunkInfo, this.chunkData(data))
      this.tableList = this.chunkInfo.lists[this.chunkInfo.index] || []

      this.isLoading = false
    },
    formatDrawTime(drawTime) {
      return moment(drawTime).format('YYYY-MM-DD HH:mm:ss')
    },
    formatRuleCode(value) {
      return ruleCodeMapping[value]
    },
    resetChunkInfo() {
      Object.assign(this.chunkInfo, { lists: [], index: 0, last: 0, isLast: false })
    },
    chunkData(data) {
      const lists = chunk(data, 30)
      const index = 0
      const last = lists.length - 1
      const isLast = index >= last
      return { lists, index, last, isLast }
    },
    showMoreInfo() {
      const { last, lists } = this.chunkInfo
      this.chunkInfo.index++
      if (this.chunkInfo.index === last) {
        this.chunkInfo.isLast = true
      }
      this.tableList = this.tableList.concat(lists[this.chunkInfo.index])
    }
  }
}
</script>
